class AnalyticService {
    createAndInsertYandexMetricaScript() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.innerHTML = `
            (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();
            for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
            k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
            (window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=103617854', 'ym');

            ym(103617854, "init", {
                ssr:true,
                clickmap:true,
                ecommerce:"dataLayer",
                trackLinks:true,
                accurateTrackBounce:true
            });
        `;

        document.body.appendChild(script);

        const noscript = document.createElement('noscript');
        noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/103617854" style="position:absolute; left:-9999px;" alt="" /></div>';
        document.body.appendChild(noscript);
    }
}

const analyticService = new AnalyticService();
export default analyticService;